// extracted by css-extract-rspack-plugin
export default {"container":"_bd7cf1e4","title":"_297cfc63","mobileBreak":"_9af3abc"};